

























































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import AppConsts from '@/lib/appconst';
import ProductForSelect from '@/store/entities/products/product-for-select'
import _ from 'lodash';
class  PageSerialNoReportRequest extends PageRequest{
    keyword:string;
    clientCode: string;
    warehouseCode: string;
}

@Component
export default class SerialNoReport extends AbpBase{
   
    //filters
    pagerequest:PageSerialNoReportRequest=new PageSerialNoReportRequest();
    changedPage : boolean = false;
    creationTime:Date[]=[];
     objectLoading :boolean=false;
    productName:string="";
    products : Array<ProductForSelect> = new Array<ProductForSelect>();
    clients=[];
    warehouses=[];
    searchProduct_OnPress =   _.debounce(this.searchProductForSelect, AppConsts.debounceDelayTime, {
        leading: false,
        trailing: true,
    });
    get list(){
      return this.$store.state.inventoryReport.serialNoes;
    }

    isClient() {
      return this.$store.state.session.client != null;
    }
    isTenant() {
      return this.$store.state.session.tenant!=null;
    }
    async getClients(){
       await this.$store.dispatch({
            type:'client/getListForSelect'
        }).then(()=>{
          var re = this.$store.state.client.clientsForSelect;
          this.$set(this.pagerequest, 'clientCode', re.length === 0 ? "" : re[0].code);
          this.clients= re;
        });
    }
    async getWarehouses(){
      await this.$store.dispatch({
            type:'warehouse/getListForSelect'
        }).then(()=>{
            var re = this.$store.state.warehouse.warehousesForSelect;
            this.$set(this.pagerequest, 'warehouseCode', re.length === 0 ? "" : re[0].id);
            this.warehouses= re;
        })
    }
    get client() {
      return this.$store.state.session.client;
    }
    get tenant() {
      return this.$store.state.session.tenant;
    }
    get loading(){
        return this.$store.state.inventoryReport.loading;
    }
    
    pageChange(page:number){
        this.$store.commit('inventoryReport/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('inventoryReport/setPageSize',pagesize);
        this.getpage();
    }

    onSearch(){
        this.$store.commit('inventoryReport/setCurrentPage',1);
        this.getpage();
    }
     async searchProductForSelect(keyword)
    {
       if(Util.isEmpty(keyword) || keyword.length<AppConsts.keyWordAtleastLength)
            return;
        this.objectLoading= true;
        this.products = await this.$store.dispatch({
                type:'product/searchProductForSelect',
                data: {
                    clientCode:this.pagerequest.clientCode,
                    keyWord:keyword
                }
        });
        this.objectLoading= false;
    }
    changeProduct()
    {
       if (Util.isNull(this.pagerequest.keyword) || Util.isEmpty(this.pagerequest.keyword)) {
            this.productName = '';
            return;
        } 
        var product = _.find(this.products,['sku', this.pagerequest.keyword]);
        if(Util.isNull(product))
        {
            this.productName="";
            return;
        }
        this.productName= product.name;
    }
    async getpage(){
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        if (this.isClient())
        {
          this.pagerequest.clientCode = this.client.code;
        }
        if (this.isTenant())
        {
          this.pagerequest.warehouseCode = this.tenant.tenancyName;
        }
        //filters
        await this.$store.dispatch({
            type:'inventoryReport/reportSerialNoes',
            data: this.pagerequest
        })
       
    }
    get pageSize(){
        return this.$store.state.inventoryReport.pageSize;
    }
    get totalCount(){
        return this.$store.state.inventoryReport.totalCount;
    }
    get currentPage(){
        return this.$store.state.inventoryReport.currentPage;
    }
     async exportToExcel(object :any)
    {
         await this.$store.dispatch({
            type: "inventoryReport/exportDetailDataSerialNoReportToExcel",
            data: 
            { 
                productId: object.productId,
                warehouseCode : object.warehouseCode
            }
        });
    }
    columns=[
      {
          title: Util.L('SKU'),
          key: 'sku'
      },
      {
          title: Util.L('ProductName'),
          key: 'productName'
      },
      {
          title: Util.L('Qty'),
          key: 'qty'
      },
     
      {
          title: Util.L('Warehouse'),
          key: 'warehouseName'
      },
     
      {
          title: Util.L('Action'),
          slot: 'action',
          width: 100,
          align: "center"
      }
    ]

    async created(){
        await this.getClients();
        await this.getWarehouses();
    }
}
